// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__EbGPb","label":"Category_label__2fCXn","content":"Category_content__1vVw-","header":"Category_header__L8C_t","location":"Category_location__KB5aS"};